import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'bmId',
    moduleType: 'BM',
    name: '业务域',
    type: 'CAT_ROOT_BM',
}
